// extracted by mini-css-extract-plugin
export var active = "styles-module__active___aRDYM";
export var card = "styles-module__card___Ve0N5";
export var contents = "styles-module__contents___qXcep";
export var details = "styles-module__details___V8Ec6";
export var discount = "styles-module__discount___h1VPX";
export var label = "styles-module__label___dHa5j";
export var plan = "styles-module__plan___HO3vW";
export var staticCard = "styles-module__staticCard___Gag96";